import { PREFIX } from '../core';

export const BuiltIn_DISAPPEAR_ANIMATE_NAME = `${PREFIX}_BuiltIn_CallBack_Disappear`;

export enum RenderStateEnum {
  render = 'render',
  disappear = 'disappear'
}
